import React, { useContext } from 'react';
import styles from '../FormContainer.module.css';
import GiftChip from '../../../../assets/icons/GiftChip';
import { getCurrencyLogo } from '../../../../utils/global';
import { InboundContext } from '../../../../context/InboundContext';

interface Props {
  name: string;
  price: string;
  variantDetails: Record<string, string>;
  imageUrl: string;
}

export default function SelectedProductPreview({ name, price, variantDetails, imageUrl }: Props) {
  const { defaultCurrency } = useContext(InboundContext);

  const isVariantDetails = Boolean(Object.keys(variantDetails).length);

  return (
    <div className={styles.selectedProductPreviewContainer}>
      <div className={styles.selectedProductPreviewHeader}>
        <img className={styles.selectedProductPreviewImage} src={imageUrl} alt={name} />
        <div className={styles.selectedProductDetailsContainer}>
          <div>{name}</div>
          <div className={styles.selectedProductPriceSection}>
            <span>
              {getCurrencyLogo(defaultCurrency)} {price}
            </span>
            <GiftChip />
          </div>
        </div>
      </div>
      {isVariantDetails && (
        <div>
          {Object.entries(variantDetails).map(([title, value]) => (
            <div key={`${title}-${value}`}>
              <span className={styles.variantOptionTitle}>{title}: </span>
              <span className={styles.variantOptionValue}>{value}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
